import {
  ICreateNavigationAuditRegexRequest,
  IUpdateNavigationAuditRegexRequest,
} from '../../types/api/request/navigationauditregexrequest';
import { INavigationAuditRegexResponse } from '../../types/api/response/navigationauditregexresponse';
import axiosClient from '../axiosClient';
import { NavigationAuditRegexEndpoints } from '../endpoints/navigationAuditRegex';

export const NavigationAuditRegexService = {
  async getAll(): Promise<INavigationAuditRegexResponse[]> {
    const res = await axiosClient.get<INavigationAuditRegexResponse[]>(
      NavigationAuditRegexEndpoints.GET_ALL,
    );
    return res.data;
  },

  async getByNavigation(navId: number): Promise<INavigationAuditRegexResponse[]> {
    const res = await axiosClient.get<INavigationAuditRegexResponse[]>(
      NavigationAuditRegexEndpoints.BY_NAVIGATION(navId),
    );
    return res.data;
  },

  async create(
    navId: number,
    payload: ICreateNavigationAuditRegexRequest,
  ): Promise<INavigationAuditRegexResponse> {
    const res = await axiosClient.post<INavigationAuditRegexResponse>(
      NavigationAuditRegexEndpoints.BY_NAVIGATION(navId),
      payload,
    );
    return res.data;
  },

  async update(
    navId: number,
    regexId: number,
    payload: IUpdateNavigationAuditRegexRequest,
  ): Promise<INavigationAuditRegexResponse> {
    const res = await axiosClient.put<INavigationAuditRegexResponse>(
      NavigationAuditRegexEndpoints.BY_ID(navId, regexId),
      payload,
    );
    return res.data;
  },

  async remove(navId: number, regexId: number): Promise<void> {
    await axiosClient.delete(NavigationAuditRegexEndpoints.BY_ID(navId, regexId));
  },
};
